import React from 'react';
import style from './exampleDescription.scss';
import { ReactMarkdownDisplay } from '../../../../PageElements/ReactMarkdownDisplay';
import { Text } from '../../../../PageElements/Text';

export const ExampleDescription = ({
  description,
  prefix,
  pageName,
  isSingleExample,
}) => {
  return (
    <div
      data-hook="example-description"
      className={
        isSingleExample
          ? `${style.singleExampleDescription}`
          : `${style.description}`
      }
    >
      <ReactMarkdownDisplay
        markdown={description}
        textSize="small"
        prefix={prefix}
        mdName={pageName}
        renderers={{
          strong: ({ children }) => (
            <Text
              weight="bold"
              tagName="span"
              inline
              size="small"
              light={!isSingleExample}
            >
              {children}
            </Text>
          ),
        }}
      />
    </div>
  );
};
